export default "__VITE_ASSET__BgjnawrJ__"